export default "__VITE_ASSET__CDdBjP1A__"